import React, {Component} from 'react'
import io from 'socket.io-client'

export default class ListaMensagens extends Component{
    constructor(){
        super()
        this.state= {
            user: 2,
            mensagem:'',
            mensagens:[
                {
                    text: 'Teste',
                    user: {
                        id: 1,
                        name: 'Joelma',
                    },
                    time:'11:00',
                },
                {
                    text: 'Teste 2',
                    user: {
                        id: 2,
                        name: 'Fulano',
                    },
                    time:'11:00',
                },
                {
                    text: 'Teste 3',
                    user: {
                        id: 1,
                        name: 'Joelma',
                    },
                    time:'11:00',
                },
                {
                    text: 'Teste',
                    user: {
                        id: 1,
                        name: 'Joelma',
                    },
                    time:'11:00',
                },
                {
                    text: 'Teste 2',
                    user: {
                        id: 2,
                        name: 'Fulano',
                    },
                    time:'11:00',
                },
                {
                    text: 'Teste 3',
                    user: {
                        id: 1,
                        name: 'Joelma',
                    },
                    time:'11:00',
                },
            ]
        }
        //this.socket = io('localhost:8080')
    }
    componentDidMount(){
        //window.scroll_div()
    }
    render(){
        return(
   
            <div className='lista-mensagens' id='mensagem-container'>
                {this.state.mensagens.map((mensagem) => {
                    let className = 'mensagem-box';
                    if(this.state.user === mensagem.user.id) {
                        className += ' mensagem-box-enviada';
                    }
                    return(
                        <div className={`${className}`}>
                            <p className='mensagem mensagem-recebida'>
                                {mensagem.text}<span className='data-mensagem'>{mensagem.time}</span>
                            </p>
                        </div>
                    )
                })}
                    {/* <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div> */}

                    {/* <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo <span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafo<span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-enviada'>
                        <p className='mensagem mensagem-enviada'>aaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbasdnfbasdnfbasmndfbnmsadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo<span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-recebida'>
                        <p className='mensagem mensagem-recebida'>aaaasdmfbkadjfbasdbfnamnsadbfnmsadbfnmsadbfnmsbo<span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-enviada'>
                        <p className='mensagem mensagem-enviada'>aaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadsmnfbadbfmnsadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo<span className='data-mensagem
                        '>11:00</span></p>
                    </div>                
                    <div className='mensagem-box mensagem-box-enviada'>
                        <p className='mensagem mensagem-enviada'>a<span className='data-mensagem
                        '>11:00</span></p>
                    </div>                
                    <div className='mensagem-box mensagem-box-enviada'>
                        <p className='mensagem mensagem-enviada'>aaasdmfbkadjfbasdbfnadsmbfmadsfbamdnfbadsmnfbadbfnmsdafbmnsadbfnmsadbfnmsadbfnmsbo<span className='data-mensagem
                        '>11:00</span></p>
                    </div>
                    <div className='mensagem-box mensagem-box-enviada'>
                        <p className='mensagem mensagem-enviada'>aaadsmnfbbfnmsbo<span className='data-mensagem
                        '>11:00</span></p>
                    </div> */}
            </div>


        )
    }
}